import {
  ADD_CITY,
  ADD_CITY_ERROR,
  ADD_CITY_SUCCESS,
  GET_CITIES,
  GET_CITIES_ERROR,
  GET_CITIES_SUCCESS,
  GET_CITY,
  GET_CITY_ERROR,
  GET_CITY_SUCCESS,
  UPDATE_CITY,
  UPDATE_CITY_ERROR,
  UPDATE_CITY_SUCCESS,
  TOGGLE_CITY_MODAL,
} from "./actionTypes";

const initialState = {
  loadingCitiesError: null,
  loadingCities: false,
  loadingCitiesSuccess: false,
  cities: [],
  city: {},
  addCityLoading: false,
  addCityError: null,
  addCitySuccess: false,
  getCityLoading: false,
  getCityError: null,
  getCitySuccess: null,
  updateCityLoading: false,
  updateCitySuccess: false,
  updateCityError: null,
  uploadingCityIcon: false,
  uploadCityIconSuccess: null,
  uploadCityIconError: null,
};

const cities = (state = initialState, action) => {
  switch (action.type) {
    case GET_CITIES:
      state = {
        ...state,
        addCitySuccess: false,
        updateCitySuccess: false,
        loadingCities: true,
        loadingCitiesError: null,
        loadingCitiesSuccess: false,
        cities: [],
        city: {},
      };
      break;
    case GET_CITIES_SUCCESS:
      state = {
        ...state,
        loadingCities: false,
        loadingCitiesError: null,
        loadingCitiesSuccess: true,
        cities: action.payload,
      };
      break;
    case GET_CITIES_ERROR:
      state = {
        ...state,
        loadingCitiesError: action.payload,
        loadingCities: false,
        loadingCitysSuccess: false,
        cities: [],
        city: {},
      };
      break;
    case TOGGLE_CITY_MODAL:
      state = {
        ...state,
        city: {},
      };
      break;
    case ADD_CITY:
      state = {
        ...state,
        addCityLoading: true,
        addCityError: null,
        addCitySuccess: false,
      };
      break;
    case ADD_CITY_SUCCESS:
      state = {
        ...state,
        addCityLoading: false,
        addCityError: null,
        addCitySuccess: true,
        city: {},
      };
      break;
    case ADD_CITY_ERROR:
      state = {
        ...state,
        addCityLoading: false,
        addCityError: action.payload,
        addCitySuccess: false,
      };
      break;
    case GET_CITY:
      state = {
        ...state,
        city: {},
        getCityLoading: true,
        getCityError: null,
        getCitySuccess: false,
      };
      break;
    case GET_CITY_SUCCESS:
      state = {
        ...state,
        city: action.payload,
        getCityLoading: false,
        getCitySuccess: false,
        getCityError: null,
      };
      break;
    case GET_CITY_ERROR:
      state = {
        ...state,
        getCityError: action.payload,
        getCityLoading: false,
        getCitySuccess: false,
      };
      break;
    case UPDATE_CITY:
      state = {
        ...state,
        updateCityLoading: true,
        updateCityError: null,
        updateCitySuccess: false,
      };
      break;
    case UPDATE_CITY_SUCCESS:
      state = {
        ...state,
        updateCityLoading: false,
        updateCityError: null,
        updateCitySuccess: true,
        city: {},
      };
      break;
    case UPDATE_CITY_ERROR:
      state = {
        ...state,
        updateCityLoading: false,
        updateCityError: action.payload,
        updateCitySuccess: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default cities;
